import {
  Button,
  Column,
  Flex,
  Row,
  SvgX,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export interface PeopleTableItemProps {
  name: string;
  email: string;
  isRemoving: boolean;
  isDisabled: boolean;
  onRemovePerson: () => void;
}

export function PeopleTableItem({
  name,
  email,
  isRemoving,
  isDisabled,
  onRemovePerson,
}: PeopleTableItemProps): JSX.Element {
  return (
    <Row alignItems="center">
      <Column className="ellipsisOverflow" phone={4}>
        {name}
      </Column>
      <Column className="ellipsisOverflow" phone={4}>
        {email}
      </Column>
      <Column phone={4}>
        <Flex
          width="100%"
          flexDirection="row"
          justifyContent="flex-end"
          alignItems="center"
          height="24px"
        >
          <Button
            variant="tertiary"
            className="tableActionButtons"
            isLoading={isRemoving}
            disabled={isDisabled}
            onClick={onRemovePerson}
          >
            <SvgX aria-label="Remove" />
          </Button>
        </Flex>
      </Column>
    </Row>
  );
}
